import { apiGet, apiUpload, apiDownloadBlob } from './client';

export interface EntityInfo {
  key: string;
  displayName: string;
  category: 'flat' | 'medium' | 'complex';
  fields: { key: string; label: string; type: string; required?: boolean }[];
  count: number;
  upsertField?: string;
}

export async function getExportableEntities() {
  return apiGet<EntityInfo[]>('/import-export/entities');
}

export async function exportEntity(entity: string, format: 'csv' | 'json' | 'xlsx') {
  const ext = format === 'xlsx' ? 'xlsx' : format;
  return apiDownloadBlob(
    `/import-export/${entity}/export?format=${format}`,
    `${entity}-export.${ext}`,
  );
}

export async function downloadTemplate(entity: string, format: 'csv' | 'xlsx' = 'csv') {
  return apiDownloadBlob(
    `/import-export/${entity}/template?format=${format}`,
    `${entity}-template.${format}`,
  );
}

export interface ImportResult {
  imported: number;
  errors: { row: number; field?: string; message: string }[];
}

export async function importEntityFile(
  entity: string,
  file: File,
  mode: 'create' | 'upsert' = 'create',
) {
  const formData = new FormData();
  formData.append('file', file);
  return apiUpload<ImportResult>(`/import-export/${entity}/import?mode=${mode}`, formData);
}
